import { IdbStore } from './idb';
import { Outbox } from './outbox';

/** The one queue of this browser profile. */
export const outbox = new Outbox(new IdbStore());
